"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ClipboardUserSolid: function() {
        return ClipboardUserSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const ClipboardUserSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M9.70711 1C8.98914 1 8.30057 1.28521 7.79289 1.79289C7.45557 2.13022 7.21646 2.5474 7.09397 3H6C4.34315 3 3 4.34315 3 6V20C3 21.6569 4.34315 23 6 23H18C19.6569 23 21 21.6569 21 20V6C21 4.34315 19.6569 3 18 3H16.906C16.7835 2.5474 16.5444 2.13022 16.2071 1.79289C15.6994 1.28521 15.0109 1 14.2929 1H9.70711ZM15 3.70711C15 3.51957 14.9255 3.33972 14.7929 3.20711C14.6603 3.0745 14.4804 3 14.2929 3H9.70711C9.51957 3 9.33972 3.0745 9.20711 3.20711C9.0745 3.33972 9 3.51957 9 3.70711V5H15V3.70711ZM12.0002 10C10.8957 10 10.0002 10.8954 10.0002 12C10.0002 13.1046 10.8957 14 12.0002 14C13.1048 14 14.0002 13.1046 14.0002 12C14.0002 10.8954 13.1048 10 12.0002 10ZM10.1135 18.3332C10.3886 17.5551 11.1307 17 12 17C12.8692 17 13.6114 17.5551 13.8864 18.3332C14.0705 18.854 14.6418 19.1269 15.1625 18.9428C15.6832 18.7588 15.9562 18.1875 15.7721 17.6668C15.2235 16.1145 13.7432 15 12 15C10.2568 15 8.77648 16.1145 8.22784 17.6668C8.0438 18.1875 8.31672 18.7588 8.83744 18.9428C9.35815 19.1269 9.92948 18.854 10.1135 18.3332Z",
        fill: "currentColor"
    })
}), "ClipboardUserSolid");
const _default = ClipboardUserSolid;
